export const REBATE_TYPE = {
  NONE: 'NONE',
  PERCENTAGE: 'PERCENTAGE',
  REVENUE_SHARE: 'REVENUE_SHARE',
};

export const VAT_STATUS = {
  RESPONSABLE_INSCRIPTO: 'IVA_RESPONSABLE_INSCRIPTO',
  EXENTO: 'IVA_EXENTO',
  MONOTRIBUTISTA: 'MONOTRIBUTISTA',
  SIN_DISCRIMINACION: 'SIN_DISCRIMINACION_IVA',
};

export const VAT_STATUS_OPTIONS = [
  { value: VAT_STATUS.RESPONSABLE_INSCRIPTO, label: 'IVA Responsable Inscripto' },
  { value: VAT_STATUS.EXENTO, label: 'IVA Exento' },
  { value: VAT_STATUS.MONOTRIBUTISTA, label: 'Monotributista' },
  { value: VAT_STATUS.SIN_DISCRIMINACION, label: 'Sin discriminación IVA' },
];

export const REBATE_TYPE_OPTIONS = [
  { value: REBATE_TYPE.NONE, label: 'Sin rebate' },
  { value: REBATE_TYPE.PERCENTAGE, label: 'Porcentaje' },
  // { value: REBATE_TYPE.REVENUE_SHARE, label: 'Revenue Share' },
];
